import { render, staticRenderFns } from "./AudioOutput.vue?vue&type=template&id=2c67ecbf&"
import script from "./AudioOutput.vue?vue&type=script&lang=ts&"
export * from "./AudioOutput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports